const initialState = {
  tableFilters: {}
};

const tabsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'tableFilters':
      return {
        ...state,
        tableFilters: action.payload
      };

    default:
      return state;
  }
};

export default tabsReducer;
